import { createRequestReducer } from 'shared/hooks/redux/hooks';
export const boilerModelsReducer = createRequestReducer('LOAD_BOILERS');
